var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(-363 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(363 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magnifier",
    transform: "translate(373.049 1332.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M35.169,27.632a16.191,16.191,0,0,0-22.9-22.9A15.877,15.877,0,0,0,9.836,24.275a.681.681,0,0,1-.094.811L1.481,33.347C-.163,34.992-.555,37.291.9,38.749L1.154,39c1.458,1.458,3.757,1.067,5.4-.577L14.8,30.179a.691.691,0,0,1,.829-.111A15.877,15.877,0,0,0,35.169,27.632ZM15.26,24.643a11.964,11.964,0,1,1,16.919,0A11.977,11.977,0,0,1,15.26,24.643Z",
    transform: "translate(-0.001 0)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(14.622 6.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M115.423,59.152a1.672,1.672,0,0,1-1.538-2.323,10.532,10.532,0,0,1,13.788-5.589,1.671,1.671,0,1,1-1.3,3.078,7.186,7.186,0,0,0-9.407,3.813A1.672,1.672,0,0,1,115.423,59.152Z",
    transform: "translate(-113.752 -50.409)",
    fill: "#fafafa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightIcon);
export default __webpack_public_path__ + "static/media/insight-icon.2c912af6e7d18d7b80ffa7b4acc154f6.svg";
export { ForwardRef as ReactComponent };